<script>
import DynamicAppFeedElement
  from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/display/DynamicAppFeedElement.vue";
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import StoryFolderFeedSelection from "%/dynamic-component-editor/options/story-folder-feed-selection";
import { PLATFORM_ENTITY_APP_NAME, STORY_ENTITY_TYPE } from "%/dynamic-component-editor/classes/platform-standard-entities";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import AppFeedOptions from "%/dynamic-component-editor/bundles/app-feed-options";
import FeedEmptyStateOptions from "%/dynamic-component-editor/bundles/feed-empty-state-options";
import FeedPlaybackOptions from "%/dynamic-component-editor/bundles/feed-playback-options";
import FeedSeparatorsOptions from "%/dynamic-component-editor/bundles/feed-separators-options";
import FeedFiltersOptions from "%/dynamic-component-editor/bundles/feed-filters-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import FeedLayoutOptions from "%/dynamic-component-editor/bundles/feed-layout-options";
import FeedDesignOptions from "%/dynamic-component-editor/bundles/feed-design-options";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "StoryFolderFeedElement",
  extends: DynamicAppFeedElement,
  separatorRowEntityType: STORY_ENTITY_TYPE,
  mixins: [StoryPageElementMixin],
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.FOLDERS,
    displayName: "Folder Feed",
    elementGroup: "storyElements",
    displayIcon: "feed",
    elementType: "element",
  },
  context: {
    appName: PLATFORM_ENTITY_APP_NAME,
  },
  optionBundles: [
    new AppearanceOptions({}, {}, false),
    AppFeedOptions,
    new FeedSeparatorsOptions(),
    new FeedFiltersOptions(),
    new FeedEmptyStateOptions(),
    new FeedPlaybackOptions(),
    new SpacingOptions(),
    new FeedLayoutOptions(),
    new FeedDesignOptions(),
  ],
  options: [
    StoryFolderFeedSelection,
  ],
  hidden: false,
  computed: {
    elementContext() {
      const element = this.dynamicComponentInstance?.getElement(this.identifier);
      const persisted = element?.options?.context || element?.context
        || this.configuration?.options?.context || this.configuration?.context || {};
      return { appName: PLATFORM_ENTITY_APP_NAME, ...persisted };
    },
    fieldName() {
      return this.getOptionValue(StoryFolderFeedSelection) || null;
    },
    feedContext() {
      if (!this.fieldName || !this.storyEntityId) {
        return {};
      }
      return {
        entityType: STORY_ENTITY_TYPE,
        pk: { id: this.storyEntityId },
      };
    },
    rowEntityType() {
      return STORY_ENTITY_TYPE;
    },
    layout() {
      if (this.editMode || !this.storyEntityId || !this.hasAnyRowComponent) {
        return null;
      }
      return true;
    },
  },
};
</script>
